import { Injectable } from "@angular/core";
import { ApiService } from "./api.base.service";
import { IAuthService } from "./contracts/auth-service";
import { SystemAccountAuthModel } from "../../models/system-account";
import { AuthInterceptor } from "../../handler/auth-interceptor";
import { SystemAccountCreationByInviteModel } from "../../models/api-models/system-account-creation-by-invite-model";
import { IWService } from "../iw.service";
import { HttpClient } from '@angular/common/http';
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { AppConfigService } from "src/app/app-config.service";

@Injectable()
export class AuthService implements IAuthService {

  baseUrl = "api/account";
  private oneClickUrl: string;

  constructor(
    private apiService: ApiService,
    public iwService: IWService,
    private http: HttpClient,
    private router: Router,
    private config: AppConfigService
  ) {
    this.oneClickUrl = this.config.settings.ONECLICK_URL;
  }

  public async login(id?: number): Promise<SystemAccountAuthModel> {
    localStorage.removeItem("iw");

    await this.iwService.login();

    if (localStorage.getItem("iw")) {
      return this.iwService.loginDapp(id);
    }

    throw new Error("Login failed");
  }

  public async loginDapp(id?: number): Promise<SystemAccountAuthModel> {
    return this.iwService.loginDapp(id);
  }

  public async logout(): Promise<void> {
    localStorage.removeItem("iw");
    localStorage.removeItem(AuthInterceptor.tokenName);
  }

  public getToken(): string {
    return localStorage.getItem(AuthInterceptor.tokenName);
  }

  public async isAuthenticated(): Promise<boolean> {
    return !!this.getToken();
  }

  async getCurrentProfile(): Promise<SystemAccountAuthModel> {
    return this.apiService.get<SystemAccountAuthModel>(
      "api/account/profile"
    );
  }

  public async RegisterWithInvite(
    model: SystemAccountCreationByInviteModel
  ): Promise<void> {
    localStorage.removeItem("iw");

    await this.iwService.login();

    if (localStorage.getItem("iw")) {
      const organizationId = await this.apiService.post<number>(
        "api/account/register-with-invite",
        model
      );

      await this.iwService.loginDapp(organizationId);
    }
  }

  /* ======================
     One Click endpoints
     ====================== */

  public onClickLogin(): Observable<any> {
    return this.http.get(
      `${this.oneClickUrl}agent/one-click-invitation`,
      { observe: 'response' }
    );
  }

  public getStatus(invitationId: string): Observable<{ status: string; data: any }> {
  return this.http.get<{ status: string; data: any }>(
    `${this.oneClickUrl}agent/status/${invitationId}`
  );
}

  getVerificationMessage(): Observable<{
    invitationId: string;
    invitationContent: string;
  }> {
    return this.http.get<{
      invitationId: string;
      invitationContent: string;
    }>(
      `${this.oneClickUrl}agent/verification-message`
    );
  }

  public getStatusVc(data: any): Observable<any> {
    return this.http.get(
      `${this.oneClickUrl}agent/statusVc/${data}`,
      { observe: 'response' }
    );
  }

  public async loginVC(
    did: string,
    id?: number
  ): Promise<SystemAccountAuthModel> {
    const user = await this.apiService.post<SystemAccountAuthModel>(
      `${this.baseUrl}/loginVC/${did}/${id}`
    );

    if (user) {
      this.setToken(user.token);
      this.router.navigate(["/"]);
      return user;
    }

    throw new Error("Login VC failed");
  }

  private setToken(token: string): void {
    localStorage.setItem("iw", token);
    localStorage.setItem(AuthInterceptor.tokenName, token);
  }
}
